import { AclEntryCondition, InheritedProductPackageAssignment, PackageAssignment } from 'common/types/Entities';

import { buildQueryParams } from '../apiHelpers';
import { _request, APIBaseResponse,APIMethod } from '../index';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const TENANTS_PATH_PREFIX = '/tenants';
const PRODUCT_PACKAGE_ASSIGNMENTS_PATH_PREFIX = 'packageassignments';

export type APIPackageAssignmentsListParams = RequestParamsBase & {
    tenantId: string;
    userGroupId?: string;
    userId?: string;
    packageId?: string;
    licenseId?: string;
};

type APIPackageAssignmentsListResponse = APIBaseResponse<
    Array<PackageAssignment>
>;

export const APIPackageAssignmentsGetList: APIMethod<APIPackageAssignmentsListParams, APIPackageAssignmentsListResponse> = (params: APIPackageAssignmentsListParams) => {
    const queryParams = buildQueryParams(params);
    return _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${PRODUCT_PACKAGE_ASSIGNMENTS_PATH_PREFIX}?${queryParams}`, undefined, params.signal);
};

export type APIPackageAssignmentDeleteParams = RequestParamsBase & {
    tenantId: string;
    packageId: string;
    userGroupId?: string;
    userId?: string;
    licenseId?: string;
};

type APIPackageAssignmentDeleteResponse = APIBaseResponse<void>;

export const APIPackageAssignmentDelete: APIMethod<APIPackageAssignmentDeleteParams, APIPackageAssignmentDeleteResponse> = (params: APIPackageAssignmentDeleteParams) => {
    const queryParams = buildQueryParams(params);
    return _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${PRODUCT_PACKAGE_ASSIGNMENTS_PATH_PREFIX}?${queryParams}`, undefined, params.signal);
};

export type APIPackageAssignmentPostParams = RequestParamsBase & {
    tenantId: string;
    productPackageId: string;
    userGroupId?: string;
    userId?: string;
    licenseId?: string;
    startDate?: string;
    endDate?: string;
    conditions?: AclEntryCondition[];
};

type APIPackageAssignmentPostResponse = APIBaseResponse<PackageAssignment>;

export const APIPackageAssignmentPost: APIMethod<APIPackageAssignmentPostParams, APIPackageAssignmentPostResponse> = (params: APIPackageAssignmentPostParams) => {
    return _request('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${PRODUCT_PACKAGE_ASSIGNMENTS_PATH_PREFIX}`, params, params.signal);
};

export type APIPackageAssignmentPutParams = RequestParamsBase & {
    tenantId: string;
    productPackageId: string;
    userGroupId?: string;
    userId?: string;
    licenseId?: string;
    startDate?: string;
    endDate?: string;
    conditions?: AclEntryCondition[];
};

type APIPackageAssignmentPutResponse = APIBaseResponse<PackageAssignment>;

export const APIPackageAssignmentPut: APIMethod<APIPackageAssignmentPutParams, APIPackageAssignmentPutResponse> = (params: APIPackageAssignmentPutParams) => {
    return _request('PUT', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${PRODUCT_PACKAGE_ASSIGNMENTS_PATH_PREFIX}`, params, params.signal);
};

export type APIInheritedPackageAssignmentsListParams = RequestParamsBase & {
    tenantId: string;
    userId: string;
};

type APIInheritedPackageAssignmentsListResponse = APIBaseResponse<Array<InheritedProductPackageAssignment>>;

export const APIInheritedPackageAssignmentsGetList: APIMethod<APIInheritedPackageAssignmentsListParams, APIInheritedPackageAssignmentsListResponse> = (params: APIInheritedPackageAssignmentsListParams) => {
    return _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/users/${params.userId}/${PRODUCT_PACKAGE_ASSIGNMENTS_PATH_PREFIX}`, undefined, params.signal);
};
